export default __webpack_public_path__ + "static/displacement-gold-11c1279b0b5a5e30b741d7a3180d6127.mp4";